import { c as _c } from "react/compiler-runtime";
import EmptyFunnelStepList from 'modules/funnels/funnel/components/empty-funnel-step-list';
import { FunnelSettingsTabbar } from 'modules/funnels/funnel/components/funnel-settings-tabbar';
import FunnelStepsList from 'modules/funnels/funnel/components/funnel-steps-list';
import FunnelStepsListSkeleton from 'modules/funnels/funnel/components/funnel-steps-list-skeleton';
import { StepsTitle } from 'modules/funnels/funnel/components/steps-title';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import type { FunnelViewProps } from 'modules/funnels/funnel/types/funnel-view-props';
import { getFunnelStepSettingTabContent } from 'modules/funnels/funnel/utils/get-funnel-step-setting-tab-content';
import { useAdaptiveStickyColomn } from 'shared/hooks/use-adaptive-sticky-colomn';
function FunnelDesktopView(t0) {
  const $ = _c(28);
  const {
    activeTab,
    funnelId,
    funnelSteps,
    isFunnelListEmpty,
    mutate,
    selectFunnelStep,
    selectFunnelStepTab,
    selectedFunnelStep,
    settingsTabs,
    tabsDisabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      indent: 20
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    adaptiveElementRef
  } = useAdaptiveStickyColomn(t1);
  let t2;
  if ($[1] !== funnelSteps?.length || $[2] !== isFunnelListEmpty) {
    t2 = !isFunnelListEmpty && <StepsTitle count={funnelSteps?.length} />;
    $[1] = funnelSteps?.length;
    $[2] = isFunnelListEmpty;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== funnelId || $[5] !== funnelSteps || $[6] !== isFunnelListEmpty || $[7] !== mutate || $[8] !== selectFunnelStep || $[9] !== selectedFunnelStep) {
    t3 = !funnelSteps ? <FunnelStepsListSkeleton /> : <FunnelStepsList funnelId={funnelId} funnelSteps={funnelSteps} mutate={mutate} selectedFunnelStep={selectedFunnelStep} selectFunnelStep={selectFunnelStep} isFunnelListEmpty={isFunnelListEmpty} />;
    $[4] = funnelId;
    $[5] = funnelSteps;
    $[6] = isFunnelListEmpty;
    $[7] = mutate;
    $[8] = selectFunnelStep;
    $[9] = selectedFunnelStep;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <aside className="bg-bg-primary border-border-100 h-full w-85 overflow-y-auto rounded-xl border px-5">{t2}{t3}</aside>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== adaptiveElementRef || $[15] !== t4) {
    t5 = <div ref={adaptiveElementRef} className="sticky top-(--dashboard-navbar-height) shrink-0">{t4}</div>;
    $[14] = adaptiveElementRef;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== activeTab || $[18] !== funnelId || $[19] !== isFunnelListEmpty || $[20] !== selectFunnelStepTab || $[21] !== selectedFunnelStep || $[22] !== settingsTabs || $[23] !== tabsDisabled) {
    t6 = <div className="flex min-w-0 flex-1 flex-col gap-5">{isFunnelListEmpty ? <EmptyFunnelStepList /> : <><FunnelSettingsTabbar activeTab={activeTab} onSelectTab={selectFunnelStepTab} tabs={settingsTabs} tabsDisabled={tabsDisabled} />{selectedFunnelStep ? getFunnelStepSettingTabContent(funnelId, selectedFunnelStep, activeTab) : <TabContentLoader />}</>}</div>;
    $[17] = activeTab;
    $[18] = funnelId;
    $[19] = isFunnelListEmpty;
    $[20] = selectFunnelStepTab;
    $[21] = selectedFunnelStep;
    $[22] = settingsTabs;
    $[23] = tabsDisabled;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div className="flex gap-10">{t5}{t6}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
export { FunnelDesktopView };